module.exports = __webpack_public_path__ + "static/media/elevator.f8e75120.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/elevator.svg
// module id = 1516
// module chunks = 0